import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import StatusContext from '../../../contexts/StatusContext'
import JobInterviewContext from '../../../contexts/JobInterviewContext'
import "./jobinterview.css"

export const DialogJobInterviewProgress= () => {

  const {
    changeLanguage,
    waitonResponse
} = React.useContext(StatusContext);

const {
 
  showProgressDialog,
 
} = React.useContext(JobInterviewContext);


  return (
   
    <React.Fragment>
   
        <Dialog
          open={showProgressDialog}
         
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              
            },
          }}
        >

        <DialogTitle className="dialogProgressTitle" style = {{fontSize:'16px', color:'maroon'}}>{changeLanguage('comprehensiveresponses', 'prepareresponse')}</DialogTitle>

        <DialogContent dividers>
         
              <div>
              <label className="dialogProgressText"> {changeLanguage('comprehensiveresponses', 'prepareresponse_1')} </label>
              <br></br>
              {waitonResponse}
              </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
    
  );
  
}